/**
 *
 * File: ProtectedRoute.js
 *
 * Purpose: Protected route comnponent for DrivePartner passenger app protected pages.
 *
 * Author:   Thomas Burgard (Software development)
 * Created:  18.04.2023
 * Modified: 18.04.2023
 *
 * Copyright (c) DrivePartner GmbH 2022
 *
 */

import { Navigate } from "react-router-dom";
import { useSelector } from "react-redux";
 
/**
 * Component: ProtectedRoute
 * 
 * Purpose: Protect DrivePartner passenger app pages with React protected route.
 * 
 * @param {*} param0 children
 * @returns children as JSX-Code
 */
const ProtectedRoute = ({ children }) => {
  const passengerServerData = useSelector((state) => state.passengerReducer);

  //----------------------------------
  // Return JSX-Code
  //
  // If userData is null, then user
  // logged out, otherwise user is 
  // logged in. Then return protected 
  // pages as children.
  //----------------------------------  
  if (!passengerServerData.userData) {
    return <Navigate to="/passengerlogin" />;
  }

  return children;
};

export default ProtectedRoute;
